import { render } from "./Home.vue?vue&type=template&id=f4a8d41e&scoped=true&bindings={\"submit\":\"options\"}"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=f4a8d41e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f4a8d41e"

export default script